/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import {
  selectAnalysisContent,
  selectDraftVersion,
  selectSharedVersion,
} from 'features/analyses/analysisSlice';

import { getFakeClientUser } from 'common/redux/security/loggedInUser/loggedInUserSlice';
import { getFreeformAnalysisSelector } from 'features/analyses/editFreeformAnalysisSlice';
import { useSelector } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';
import useVersionToggle from 'common/hooks/useVersionToggle';
import useIsMountedRef from 'common/hooks/useIsMountedRef';
import { useIsPreviousVersionSelected } from 'common/hooks/useIsPreviousVersionSelected';
import { CommentingProps } from '../types';
import CommentingMFE from '../inlineCommenting/index';

export const AnalysisInlineCommenting = (props: CommentingProps) => {
  const isMountedRef = useIsMountedRef();
  const { projectId } = useParams<{
    analysisId: string;
    projectId: string;
  }>();

  const isFakeClientUser = useSelector(getFakeClientUser);
  const { analysis: analysisEdit } = useSelector(getFreeformAnalysisSelector);
  const analysisContent = useSelector(selectAnalysisContent);
  const draftVersion = useSelector(selectDraftVersion);
  const sharedVersion = useSelector(selectSharedVersion);
  const location = useLocation();

  const { isEntitySharedWithClient } = useVersionToggle(
    isMountedRef.current,
    draftVersion,
    sharedVersion
  );
  const isPreviousVersionSelected = useIsPreviousVersionSelected();
  const isEditPage = location.pathname.endsWith('edit');
  // analysisContent => Has the content Id in View Mode
  // analysisEdit => Has the content ID in Edit mode. Also has similar content Id in draftVersion
  // draftVersion => When the user is in Client Mode and Clicks on Edit only the draft Version has the Updated Version. After the user clicks on Done analysisEdit gets updated

  if (analysisContent || draftVersion || (isEditPage && analysisEdit)) {
    const { contentId } = analysisContent || draftVersion || analysisEdit;
    return (
      <CommentingMFE
        {...props}
        contentId={contentId}
        isFakeClientUser={isFakeClientUser}
        projectId={projectId}
        isShared={isEntitySharedWithClient}
        isPreviousVersionSelected={isPreviousVersionSelected}
      />
    );
  }

  return <></>;
};
